<div class="modal-header" *ngIf="product">
  <h4 class="modal-title">{{ product.nombre }}</h4>
  <button type="button" class="btn-close" aria-label="Cerrar" (click)="activeModal.dismiss('cancel')"></button>

</div>
<div class="modal-body">
  <div class="container mt-5 mb-5" *ngIf="product?.id">
    <div class="row">
      <!-- Imagen principal + Thumbnails -->
      <div class="col-md-5">
        <div class="border rounded p-2 text-center mb-3">
          <img [src]="activeImage || product.photo" class="img-fluid main-image"
            [alt]="product.nombre || 'Producto seleccionado'">

        </div>


        <!-- Colores -->
        <div *ngIf="product.colores?.length" class="mb-2">
          <strong>Colores:</strong>

          <div class="product-colors d-flex flex-wrap gap-2">
            <div *ngFor="let color of product.colores" class="color-swatch-wrapper">
              <div class="color-swatch" [style.backgroundColor]="color.hex" [title]="color.nombre"></div>
              <small class="text-muted">{{ color.nombre }}</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Información del producto -->
      <div class="col-md-7">
        <h1 class="mb-3">{{ product.nombre }}</h1>
        <p class="text-muted mb-1"><strong>SKU:</strong> {{ product.serie }}</p>

        <!-- Precios detallados -->
        <div class="product-prices mt-3 mb-4">
          <!-- Precio contado (efectivo) -->
          <p class="mb-1">
            <strong class="text-success">Precio Contado:</strong>
            <span class="font-weight-bold" style="font-size: 1.3rem;">
              ${{ product.precioCon * cotizacion | number:'1.2-2' }}
            </span>
            <span class="badge bg-success ml-2">
              Ahorrás ${{ ((product.precioLis - product.precioCon) * cotizacion) | number:'1.2-2' }}
              ({{ (((product.precioLis - product.precioCon) / product.precioLis * 100) * cotizacion) | number:'1.0-0'
              }}%)
            </span>
          </p>

          <!-- Precio lista -->
          <p class="mb-1">
            <strong class="text-muted">Precio Tarjeta:</strong>
            <span class="text-primary font-weight-bold" style="font-size: 1.4rem;">
              ${{ product.precioLis * cotizacion | number:'1.2-2' }}
            </span>
          </p>

          <!-- Precio débito
          <p *ngIf="product.precioDeb" class="mb-1">
            <strong class="text-info">Precio Lista:</strong>
            <span class="font-weight-bold">
              ${{ product.precioDeb *cotizacion | number:'1.2-2' }}
            </span>
          </p>
          -->
          <!-- Precio mayorista -->
          <p *ngIf="product.cantOferta && rol==3" class="mb-1">
            <strong class="text-warning">Precio Mayorista:</strong>
            <span class="font-weight-bold">
              ${{ product.precioMay *cotizacion | number:'1.2-2' }}
            </span>
            <small class="text-muted ml-2">(Aplicable por {{product.cantOferta}} unidades)</small>
          </p>
        </div>


        <p class="product-description" [innerHTML]="descripcionConSaltos"></p>



        <!-- Control de cantidad -->
        <div class="form-group d-flex align-items-center mt-4">
          <label for="qty" class="mr-2 mb-0">Cantidad:</label>
          <div class="input-group" style="width: 120px;">
            <div class="input-group-prepend">
              <button class="btn btn-outline-secondary" (click)="decreaseQty()">-</button>
            </div>
            <input type="number" id="qty" class="form-control text-center" [(ngModel)]="quantity" min="1">
            <div class="input-group-append">
              <button class="btn btn-outline-secondary" (click)="increaseQty()">+</button>
            </div>
          </div>
        </div>

        <!-- Botón agregar -->
        <div class="mt-4">
          <button class="btn btn-primary btn-lg" (click)="addToCart()" [disabled]="product.stock <= 0">
            <i class="fas fa-cart-plus mr-2"></i>
            {{ product.stock > 0 ? 'Agregar' : 'Sin stock' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.dismiss('cancel')">Cerrar</button>
</div>